import React from 'react'

import { Field } from 'formik'

import { KeyEventUtil } from 'utils'

import { SelectSede } from 'sharedComponents/select'

import { Form, Col } from '_zari/core'

const SedeFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-reporteCobranzas-usuario', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='SUCURSAL' htmlFor='select-reporteCobranzas-sede' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idSede'>
          {({ field }) => (
            <SelectSede
              {...field}
              id='select-reporteCobranzas-sede'
              titulo='Todas'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(SedeFormGroup)
